/**
 * $Revision: 0001 $
 * $Date: 2017-12-17 14:19:02 +0800 $
 * $Author: chenwenxian $
 */
//import jstracker from 'jstracker'
import { API_URL, APP_UA, APP_KEY, APP_AKEY } from 'config'
var A_MINUTE = 60000
var AN_HOUR = 3600000
var A_DAY = 86400000

var Apm = function(opts){
    //默认参数
    var _ts = this,
        defOpts = {
        };
    this.opts = Object.assign(defOpts, opts);

    this.config = {
        //platform: "",
        platform: (navigator.userAgent.toLowerCase()).match(/iphone|ipod|ipad/ig) ? 'ios' : 'android',
        app: {
            isInApp: _ts.app.isInApp || false, // aipai/Android/paidashi/paidashi/v(857)  or false
            //is: registerApm.app.is,               //true or false
            o : _ts.app.os || null,       //系统
            s : _ts.app.set || null,      //产品线
            p : _ts.app.product || null,  //app名
            v: _ts.app.version  || null   //版本号
        }
    };
    this.tools = {
        getUrlName: function (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r !== null) return unescape(r[2]);
            return null;
        },
        loadJS: function(url, success){
            var domScript = document.createElement('script');
                domScript.src = url;
                success = success || function(){};
            if(navigator.userAgent.indexOf("MSIE")>0){
                domScript.onreadystatechange = function(){
                    if('loaded' === this.readyState || 'complete' === this.readyState){
                        success();
                        this.onload = this.onreadystatechange = null;
                        this.parentNode.removeChild(this);
                    }
                }
            }else{
                domScript.onload = function(){
                    success();
                    this.onload = this.onreadystatechange = null;
                    this.parentNode.removeChild(this);
                }
            }
            document.getElementsByTagName('head')[0].appendChild(domScript);
        },
        //输出数据，过滤key不存在导致报错问题
        returnData: function (data, keyArr) {
            /*
                data 表示对象
                keyArr 表示数组，['key1', 'key2']
                ==> 表示需要返回 data['key1']['key2'] 的值，其中有某个key不存在就返回: ""（空）
            */
            if (typeof keyArr === "object") {
                try {
                    return eval("data" + "." + keyArr.join("."));
                } catch (e) {
                    return "";
                }
            } else {
                try {
                    return data;
                } catch (e) {
                    return "";
                }
            }
        },
        /**
         * [zkopen_web 客户端内打开]
         * @param  [type] url            [description]
         * @param  [type] need_user_info [description]
         * @param  [type] open_type      [web内部打开，safari外部打开（相当于_blank）]
         * @return [type]                 [description]
         * example shareUrl, 'Y', 'web'
         */
        zkopen_web: function(url, needUserInfo, openType) {
          if (!url) return false;
          needUserInfo = needUserInfo == 'Y' ? 'Y' : 'N';
          var cmd = {
            open_type: openType,
            web_url: url,
            need_user_info: needUserInfo
          };
          var cmdStr = JSON.stringify(cmd);
          var cmdEncodeStr = encodeURIComponent(cmdStr);
          return 'zkopenthirdapp://?_zkcmd=open_type&iphone_cmd_arg=' + cmdEncodeStr + '&androidphone_cmd_arg=' + cmdEncodeStr;
        }
        /*function loadScript(src, callback) {
            var script = document.createElement('script'),
                head = document.getElementsByTagName('head')[0];
            script.type = 'text/javascript';
            script.charset = 'UTF-8';
            script.src = src;
            if (script.addEventListener) {
                script.addEventListener('load', function () {
                    callback();
                }, false);
            } else if (script.attachEvent) {
                script.attachEvent('onreadystatechange', function () {
                    var target = window.event.srcElement;
                    if (target.readyState == 'loaded') {
                        callback();
                    }
                });
            }
            head.appendChild(script);
        }

        loadScript('http://m.aipai.com/aipai_platform/mobile/common/dist/weixin/1.0.0/jweixin.js',function(){
            console.log('wenxian', wx);
        });*/
    };
    this.init();
};

Apm.prototype.install = function(Vue){
    Vue.prototype.$apm = this;
    Vue.apm = this;
};

//初始化
Apm.prototype.init = function(){
    var _ts = this;

    window.WinObserver = {
      //订阅
      add: function (callback, opt) {
        this.subscribers[this.subscribers.length] = {
          callback: callback,
          opt: (opt !== 'undefined') ? opt : {}
        };
      },
      //退订
      remove: function (callback) {
        for (var i = 0; i < this.subscribers.length; i++) {
          if (this.subscribers[i].callback === callback) {
            delete (this.subscribers[i]);
          }
        }
      },
      //发布
      publish: function (what, _observer) {
        let data = {}
        for (var i = 0; i < this.subscribers.length; i++) {
          if (this.subscribers[i] && typeof this.subscribers[i].callback === 'function') {
            let observer = (_observer !== 'undefined') ? _observer : {};
            let key = observer.type+'_'+what.type
            // 执行注册的各种回调
            data[key] = this.subscribers[i].callback({param: what, opt: this.subscribers[i].opt, observer: observer});
          }
        }
        return data
      },
      // 将对象o具有观察者功能
      make: function (o) { 
        for (var i in this) {
          o[i] = this[i];
          o.subscribers = [];
        }
      }
    };

    //订阅对象
    window.WinSubscribe = {
      WINBDClient: function(data){
        return this.publish(data, {type: 'WINBDClient'});
      }
    }
    //增加订阅观察者模式
    window.WinObserver.make(window.WinSubscribe);
    //客户端调用WINBDClient，发布协议
    window.WINBDClient = function(param){
      let data = window.WinSubscribe.WINBDClient(param);
      let key = 'WINBDClient_'+param.type
      let _data = data[key] ? data[key] : {stat: 0, data: {}}
      return  _data
    }
};

//apm.app
Apm.prototype.app = (function() {
    var ua = navigator.userAgent,
        opt = {};
    var reg = ua.match(/aipai\/(.*)\/(.*)\/(.*)\/v\((.*)\)/);
    if(reg){
        opt.isInApp = reg[0];
        opt.os = reg[1];
        opt.set = reg[2];
        opt.product = reg[3];
        opt.version = reg[4];
    }else{
        opt.isInApp = false;
    }

    opt.is = function (arg){
        if(reg){
            return (typeof arg.o !== 'undefined' ? (arg.o === opt.os) : true) &&  (typeof arg.p !=='undefined' ? (arg.p === opt.product) : true) && (typeof arg.s !== 'undefined' ? (arg.s === opt.set) : true) && (typeof arg.v !== 'undefined' ? (opt.version >= arg.v) : true);
        }else{
            return false;
        }
    };
    return opt;
})();

/*
注册：this.$apm.globalEvent.addEventListener("wenxian", function(tips){alert(tips); })
触发：(function(){var evt = new window.Event('wenxian'); evt.param ={}; evt.cbparam ={}; window.document.dispatchEvent(evt);})();
*/
//全局事件
Apm.prototype.globalEvent = {
    //track varies kinds of events and listeners.
    handlerTraker: {},
    /**
    * addEventListener
    * NOTE: one callback can only be bound to the same event once. Bind a callback twice doesn't
    *  mean it will be called twice when the event fired once.
    * @param {string} evt - the event name to add a listener on.
    */
    add: function (evt, callback) {
        var _ts = this;
        if (!callback) {
            {
                console.error("[vue-render] missing callback arg in globalEvent.addEventListener.");
            }
            return
        }
        var handlers = _ts.handlerTraker[evt];
        if (!handlers) {
            handlers = _ts.handlerTraker[evt] = [];
        }
        var len = handlers.length;
        for (var i = 0; i < len; i++) {
            if (handlers[i] === callback) {
                // this callback is already bound. no need to bind it again.
                return
            }
        }
        handlers.push(callback);
        document.addEventListener(evt, callback);
    },

    /**
    * removeEventListener
    * NOTE: remove all the event handlers for the specified event type.
    * @param {string} evt - the event name to remove a listener from.
    */
    remove: function(evt) {
        var _ts = this,
            handlers = _ts.handlerTraker[evt];
        if (!handlers) {
          // evt handlers has been already removed.
          return
        }
        handlers.forEach(function (cb) { return document.removeEventListener(evt, cb); });
        delete _ts.handlerTraker[evt];
    }
};

//app协议
Apm.prototype.appClient = function(param){
    try {
        var reg = new RegExp(APP_UA, 'ig')
        if (navigator.userAgent.match(reg)) {
            var _param = Object.assign({}, {
                type: '',
                data: {}
            }, param)
            if (typeof _param.data.cbParam == 'undefined') { _param.data.cbParam = {} }
            if (typeof _param.data.cbName == 'undefined') { _param.data.cbName = '' }
            _param = JSON.stringify(_param)
            var data = null
            console.log(_param)
            if(!navigator.userAgent.match(/iphone|ipod/ig)){
                data = window.BDClient.call(_param)
            }else{
                //data = window.webkit.messageHandlers.BDClient.postMessage(_param)
                data = window.prompt(_param)
            }
            var _data = typeof data == 'string' ? JSON.parse(data) : data
            return _data
        }else{
            return {
                stat: 0,
                msg: '不在客户端内'
            }
        }
    } catch (err) {
        return {
            stat: 0,
            msg: '协议执行失败'
        }
    }
}

Apm.prototype.getHasFlagData = function(sign_arg, data){
    if(!sign_arg){ return data; }
    var _time = String( Date.parse(new Date())/1000 ),
        sign_args = sign_arg.split('|'),
        prefix = sign_args[0],
        sign_argStr = sign_args[1],
        sign_argArr = sign_argStr.split(','),
        baseParams = this.getBaseParams(),
        allParams = Object.assign(baseParams, data, {_time: _time}),
        _flag = APP_KEY + prefix;
    sign_argArr.map((key)=>{
      _flag += allParams[key]
    })
    _flag += allParams['_time']

    return Object.assign(data, {
      _flag: (this.md5((this.md5(_flag)).toLowerCase())).toLowerCase(),
      _time: allParams['_time']
    })
}


//app检查参数
Apm.prototype.getBaseParams = function(){
    var reg = new RegExp(APP_UA, 'ig');
    var baseParams = {
      _app_id: '',
      _version: '',
      _v: '',
      _brand: '',//apple
      _systype: navigator.userAgent.match(/iphone|ipod/ig) ? 'iphone' : 'androidphone',
      _platform: '', // app or wechat or baidu
      _udid: '',
      _uid: '',
      _utoken: '',
      _uauthCode: ''
    };
    var pageData = {};
    var cbData = this.appClient({
      type: 'getBaseInfo',
      data: {}
    })
    if(cbData.stat == 1){
      pageData = cbData.data
    }
    if(!pageData._uid){
      let paramArr = window.location.search.substr(1).split('&');
      for(let i=0; i<paramArr.length; i++){
        if(paramArr[i].match(/(.+?)=(.+?)/ig)){
          let curArr = paramArr[i].split('=');
          pageData[curArr[0]] = decodeURIComponent(curArr[1]);
        }
      }
    }
    //存储到本地
    /*if(pageData._uid && pageData._udid){
      storage.setItem({ pageData: pageData })
    }else{
      pageData = storage.getItem('pageData') || {}
    }
    if(typeof name != 'undefined'){
      return pageData[name] || ''
    }else{
      return pageData
    }*/

    baseParams = Object.assign(baseParams, {
      _app_id: pageData._app_id || '',
      _version: pageData._version || '',
      _v: pageData._v || '',
      _systype: pageData._systype || '',
      _brand: pageData._brand || '',
      _udid: pageData._udid || '',
      _uid: pageData._uid || '',
      _utoken: pageData._utoken || '',
      _platform: pageData._platform || ''
    })
    return baseParams
}


//当前app是否存在type协议
Apm.prototype.appIsBridge = function(type){
    
};

//app接口
Apm.prototype.appBridge = function(type, _data){
    var data = _data || null,
        iframe = document.createElement('IFRAME');
    iframe.setAttribute('src', 'lieyou-vw://'+type+'/'+encodeURIComponent(JSON.stringify(data)));
    document.documentElement.appendChild(iframe);
    iframe.parentNode.removeChild(iframe);
    iframe = null;
};

Apm.prototype.refresh = function(type){
};

Apm.prototype.pageData = (()=>{
    let pageData = {};
    let paramArr = window.location.search.substr(1).split('&');
    for(let i=0; i<paramArr.length; i++){
        if(paramArr[i].match(/(.+?)=(.+?)/ig)){
            let curArr = paramArr[i].split('=');
            pageData[curArr[0]] = decodeURIComponent(curArr[1]);
        }
    }
    return pageData;
})()

//启动app某个页面协议
Apm.prototype.appStart = function(data){
};


Apm.prototype.wxShare = function(opt){
    var shareTitle = opt.title || document.title;
    var shareDesc = opt.desc || '';
    var shareLink = opt.link || location.href;
    var sharePic = opt.imgUrl || 'https://zkres.myzaker.com/data/ads_web/share_pic.png';
    var shareTimelineDesc = opt.lineDesc || opt.desc || '';
    window.zk_get_share_info = function () {
        var zk_web_wxshare_param = {
            shareTitle: shareTitle,
            shareDesc: shareDesc,
            shareLink: shareLink,
            sharePic: sharePic,
            shareTimelineDesc: shareTimelineDesc
        };
        var arr = {
            type: "zk_web_wxshare_param",
            result: zk_web_wxshare_param
        };
        return JSON.stringify(arr);
    }

    var sharesuccessFunc = function () {
        if(opt.sucFun && typeof opt.sucFun == 'function'){
            opt.sucFun();
        }
        //var img = document.createElement("img");
        //img.src = "https://stat.myzaker.com/stat_h5_share.php?id=turkishairlines_20190226";
    };
    var sharecancelFunc = function () { };
    var scriptdom = document.createElement("script");
    scriptdom.type = "text/javascript";
    scriptdom.src = "https://huodong.myzaker.com/wx/wechat_js_api_new.php?v=1";
    document.body.appendChild(scriptdom);
    scriptdom.onload = function () {
        wxShareNew.init(shareTitle, shareDesc, shareTimelineDesc, shareLink, sharePic, sharesuccessFunc, sharecancelFunc);
    }
};

// 回到顶部
Apm.prototype.initScrollTop = function(){
    var st = null,
        _scTop = document.createElement('span');
    _scTop.setAttribute('class','g_scrollTop hidden');
    _scTop.setAttribute('id','g_scrollTop');

    document.body.appendChild(_scTop);
    var _el = document.getElementById('g_scrollTop');
    window.addEventListener('scroll', function(event){
        clearTimeout(st);
        st = setTimeout(function(){
            if(document.body.scrollTop > window.innerHeight){
                _el.style.display = 'block';
                _el.addEventListener('click', function(event) {
                    _el.style.display = 'none';
                    event.preventDefault();
                    window.scrollTo(0,0);
                });
            }else{
                _el.style.display = 'none';
            }
        },50);
    });
    _el.addEventListener('touchstart', function(event){
        _el.classList.add('cur');
    });
    _el.addEventListener('touchend', function(event){
        _el.classList.remove('cur');
    });
};

Apm.prototype.fetch = function(_opt){
    var _ts = this,
        pageData = _ts.pageData,
        param = "",
        //isCookies = opt.
        opt = Object.assign({
            method: "GET",
            type: "json",
            cookies: true, //Boolean
            timeout: 10000,
            param: null, //{id: 123}
            paramType: 0, // 0表示参数以字符串形式提交比如“wen=12&xx=333”; 1表示参数以对象形式提交比如“{wen:12, xx:33}”
            headers: {},
            base: true
        }, _opt);
    var baseParams = this.getBaseParams();
    if(opt.base){
        opt.param = Object.assign({}, baseParams, opt.param);
    }
    //flag
    opt.param = this.getHasFlagData(opt.sign_arg, opt.param);
    
    if(baseParams._uauthCode){
        opt.headers = Object.assign({}, {'Authorization': APP_AKEY + ' ' + baseParams._uauthCode}, opt.headers);
    }
    
    console.log('opt.param', opt.param);
    //默认补上
    /*opt.param = Object.assign({
        os: (_ts.config.platform === "ios") ? 2 : 1,
        versionCode: parseInt(_ts.config.app.v, 10) || 0
    }, opt.param);*/

    //start zaker url 如果页面有登陆就需要补上用户信息: opt.url
    opt.url = (opt.url.indexOf('http')>=0)? `${opt.url}` : `${API_URL}${opt.url}`
    /*var _loginUrl = '',
        _appid = pageData._appid,
        _udid = pageData._udid,
        _uid = pageData._uid,
        _v = pageData._v,
        _version = pageData._version,
        _webcode = pageData._webcode;
    if(pageData._uid && pageData._appid && pageData._udid){
        _loginUrl = '_appid='+_appid+'&_udid='+_udid+'&_uid='+_uid+'&_v='+_v+'&_version='+_version+'&_webcode='+_webcode;
        opt.url = opt.url+((opt.url).indexOf('?')>=0 ? '&' : '?')+_loginUrl;
    }*/
    //end zaker url 如果页面有登陆就需要补上用户信息: opt.url

    if(location.protocol === 'https:'){
        opt.url = (opt.url).replace(/^http:(\/\/)/, "$1");
    }
    if(location.protocol === 'http:'){
        opt.url = (opt.url).replace(/^https:(\/\/)/, "$1");
    }
    if(opt.param !== null){
        for(var key in opt.param){
            if(typeof opt.param[key] !== 'function'){
                param += '&'+key+'='+ encodeURIComponent(opt.param[key]);
            }
        }
        param = param.substring(1);
    }
    if((opt.method).toLowerCase() === "get"){
        if(opt.type === 'jsonp'){
            return fetchJsonp(opt.url+((opt.url).indexOf('?') >=0 ? '&': '?')+param, {
                timeout: opt.timeout,
                method: opt.method,
                headers: opt.headers,
                credentials: opt.cookies ? 'include' : ''
            }).then(function(response){
                return response.json();
            }).then(function(json){
                return json;
            }).catch(function(ex){
                // 网络错误
                return {error: true, url: ex};
            });
        }else{
            return axios(opt.url+((opt.url).indexOf('?') >=0 ? '&': '?')+param, {
                method: opt.method,//"get",
                timeout: opt.timeout,
                withCredentials: opt.cookies,
                headers: opt.headers
            }).then(function(response){
                return response.data;
            }).catch(function(ex){
                return {error: true, url: ex};
            });
        }
    }else{
        return axios(opt.url, {
            method: opt.method,//"post",
            timeout: opt.timeout,
            data: (opt.paramType == 0) ? param : opt.param,
            withCredentials: opt.cookies,
            headers: opt.headers
        }).then(function(response){
            return response.data;
        }).catch(function(ex){
            return {error: true, url: ex};
        });

        /*return axios.post(opt.url+'?'+param, {
            timeout: opt.timeout,
            withCredentials: opt.cookies //带上cookie
        }).then(function(response){
            return response.data;
        }).catch(function(ex){
            return {error: true, url: ex};
        });*/
    }
};

Apm.prototype.molg = function(data){

    let _ts = this,
        pageData = _ts.pageData,
        _appid = pageData._appid,
        _udid = pageData._udid,
        _uid = pageData._uid,
        _v = pageData._v,
        _version = pageData._version,
        _webcode = pageData._webcode,
        url = '';
    for(let key in data){
        url += '&'+key+'='+ encodeURIComponent(data[key]);
    }
    if(pageData._uid && pageData._appid && pageData._udid){
        //补用户信息
        url += '&_appid='+_appid+'&_udid='+_udid+'&_uid='+_uid+'&_v='+_v+'&_version='+_version+'&_webcode='+_webcode;
    }
    url = url.substring(1);

    //console.log('//stat.myzaker.com/stat_h5.php?'+url);
    (new Image()).src = '//stat.myzaker.com/stat_h5.php?'+url;
}

Apm.prototype.timeSince = function(dateStr, formatStr = 'yyyy-MM-dd hh:mm') {
    dateStr = dateStr + ''
    dateStr *= (dateStr.length === 10 ? 1000 : 1)
    if (!dateStr) {
      return ''
    }
    var date = new Date(dateStr)
    var recorded = date.valueOf()
    var today = new Date().setHours(0, 0, 0, 0)
    var yesterday = today - A_DAY
    var theDayBefore = yesterday - A_DAY
    var now = new Date().valueOf()
    var diffFromRecorded = now - recorded

    if (diffFromRecorded < A_MINUTE) {
      return '刚刚'
    }

    if (diffFromRecorded < AN_HOUR) {
      return parseInt(`${diffFromRecorded / A_MINUTE}`) + '分钟前'
    }

    if (diffFromRecorded < now - today) {
      return parseInt(`${diffFromRecorded / AN_HOUR}`) + '小时前'
    }
    if (diffFromRecorded < now - yesterday) {
      return this.formatTimestamp(dateStr, '昨天 hh:mm')
    }
    if (diffFromRecorded < now - theDayBefore) {
      return this.formatTimestamp(dateStr, '前天 hh:mm')
    }
    return this.formatTimestamp(dateStr, formatStr)
}

Apm.prototype.timeToSec = function(str) {
  if (!str) {
    return 0
  }
  var arr = str.split(':')
  var sec = 0
  var length = arr.length - 1
  for (var i = 0; i <= length; i++) {
    sec = sec + arr[i] * Math.pow(60, length - i)
  }
  return sec
}

Apm.prototype.formatTimestamp = function(dateStr, str) {
  if (!str) str = 'MM-dd'
  dateStr = dateStr + ''
  dateStr *= (dateStr.length === 10 ? 1000 : 1)
  var date = new Date(dateStr)
  var regExArr = ['y+', 'M+', 'd+', 'h+', 'm+', 's+', 'q+', 'S']
  var resultArr = [
    date.getFullYear(),
    date.getMonth() + 1,
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    Math.floor((date.getMonth() + 3) / 3),
    date.getMilliseconds()
  ]
  for (var i = 0; i < regExArr.length; i++) {
    var pattern = regExArr[i]
    var result = resultArr[i]
    var regEx = new RegExp('(' + pattern + ')')
    if (regEx.test(str)) {
      if (pattern === 'y+') {
        str = str.replace(regEx, result)
      } else {
        var replaceStr = result.toString()
        // replaceStr = ('00' + replaceStr).substring(replaceStr.length)
        replaceStr = this.addO(replaceStr)
        str = str.replace(regEx, replaceStr)
      }
    }
  }
  return str
}

Apm.prototype.addO = function(str) {
  str = str + ''
  if (str.length > 1) {
    return str
  }
  var temp = '00' + str
  return temp.substring(str.length)
}

//apm.md5
Apm.prototype.md5 = function(value){
    var hex_chr = "0123456789abcdef",
        rhex = function(num) {
            var str = "";
            for(var j = 0; j <= 3; j++)
                str += hex_chr.charAt((num >> (j * 8 + 4)) & 0x0F) +
                    hex_chr.charAt((num >> (j * 8)) & 0x0F);
            return str;
        },
        str2blks_MD5 = function(str) {
            var nblk = ((str.length + 8) >> 6) + 1;
            var blks = new Array(nblk * 16);
            for(var i = 0; i < nblk * 16; i++) blks[i] = 0;
            for(var i = 0; i < str.length; i++)
                blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
            blks[i >> 2] |= 0x80 << ((i % 4) * 8);
            blks[nblk * 16 - 2] = str.length * 8;
            return blks;
        },
        add = function(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        },
        rol = function(num, cnt) {
            return (num << cnt) | (num >>> (32 - cnt));
        },
        cmn = function(q, a, b, x, s, t) {
            return add(rol(add(add(a, q), add(x, t)), s), b);
        },
        ff = function(a, b, c, d, x, s, t) {
            return cmn((b & c) | ((~b) & d), a, b, x, s, t);
        },
        gg = function(a, b, c, d, x, s, t) {
            return cmn((b & d) | (c & (~d)), a, b, x, s, t);
        },
        hh = function(a, b, c, d, x, s, t) {
            return cmn(b ^ c ^ d, a, b, x, s, t);
        },
        ii = function(a, b, c, d, x, s, t) {
            return cmn(c ^ (b | (~d)), a, b, x, s, t);
        },
        MD5 = function(str) {
            var x = str2blks_MD5(str);
            var a =  1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d =  271733878;

            for(var i = 0; i < x.length; i += 16){
                var olda = a;
                var oldb = b;
                var oldc = c;
                var oldd = d;

                a = ff(a, b, c, d, x[i+ 0], 7 , -680876936);
                d = ff(d, a, b, c, x[i+ 1], 12, -389564586);
                c = ff(c, d, a, b, x[i+ 2], 17,  606105819);
                b = ff(b, c, d, a, x[i+ 3], 22, -1044525330);
                a = ff(a, b, c, d, x[i+ 4], 7 , -176418897);
                d = ff(d, a, b, c, x[i+ 5], 12,  1200080426);
                c = ff(c, d, a, b, x[i+ 6], 17, -1473231341);
                b = ff(b, c, d, a, x[i+ 7], 22, -45705983);
                a = ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
                d = ff(d, a, b, c, x[i+ 9], 12, -1958414417);
                c = ff(c, d, a, b, x[i+10], 17, -42063);
                b = ff(b, c, d, a, x[i+11], 22, -1990404162);
                a = ff(a, b, c, d, x[i+12], 7 ,  1804603682);
                d = ff(d, a, b, c, x[i+13], 12, -40341101);
                c = ff(c, d, a, b, x[i+14], 17, -1502002290);
                b = ff(b, c, d, a, x[i+15], 22,  1236535329);

                a = gg(a, b, c, d, x[i+ 1], 5 , -165796510);
                d = gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
                c = gg(c, d, a, b, x[i+11], 14,  643717713);
                b = gg(b, c, d, a, x[i+ 0], 20, -373897302);
                a = gg(a, b, c, d, x[i+ 5], 5 , -701558691);
                d = gg(d, a, b, c, x[i+10], 9 ,  38016083);
                c = gg(c, d, a, b, x[i+15], 14, -660478335);
                b = gg(b, c, d, a, x[i+ 4], 20, -405537848);
                a = gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
                d = gg(d, a, b, c, x[i+14], 9 , -1019803690);
                c = gg(c, d, a, b, x[i+ 3], 14, -187363961);
                b = gg(b, c, d, a, x[i+ 8], 20,  1163531501);
                a = gg(a, b, c, d, x[i+13], 5 , -1444681467);
                d = gg(d, a, b, c, x[i+ 2], 9 , -51403784);
                c = gg(c, d, a, b, x[i+ 7], 14,  1735328473);
                b = gg(b, c, d, a, x[i+12], 20, -1926607734);

                a = hh(a, b, c, d, x[i+ 5], 4 , -378558);
                d = hh(d, a, b, c, x[i+ 8], 11, -2022574463);
                c = hh(c, d, a, b, x[i+11], 16,  1839030562);
                b = hh(b, c, d, a, x[i+14], 23, -35309556);
                a = hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
                d = hh(d, a, b, c, x[i+ 4], 11,  1272893353);
                c = hh(c, d, a, b, x[i+ 7], 16, -155497632);
                b = hh(b, c, d, a, x[i+10], 23, -1094730640);
                a = hh(a, b, c, d, x[i+13], 4 ,  681279174);
                d = hh(d, a, b, c, x[i+ 0], 11, -358537222);
                c = hh(c, d, a, b, x[i+ 3], 16, -722521979);
                b = hh(b, c, d, a, x[i+ 6], 23,  76029189);
                a = hh(a, b, c, d, x[i+ 9], 4 , -640364487);
                d = hh(d, a, b, c, x[i+12], 11, -421815835);
                c = hh(c, d, a, b, x[i+15], 16,  530742520);
                b = hh(b, c, d, a, x[i+ 2], 23, -995338651);

                a = ii(a, b, c, d, x[i+ 0], 6 , -198630844);
                d = ii(d, a, b, c, x[i+ 7], 10,  1126891415);
                c = ii(c, d, a, b, x[i+14], 15, -1416354905);
                b = ii(b, c, d, a, x[i+ 5], 21, -57434055);
                a = ii(a, b, c, d, x[i+12], 6 ,  1700485571);
                d = ii(d, a, b, c, x[i+ 3], 10, -1894986606);
                c = ii(c, d, a, b, x[i+10], 15, -1051523);
                b = ii(b, c, d, a, x[i+ 1], 21, -2054922799);
                a = ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
                d = ii(d, a, b, c, x[i+15], 10, -30611744);
                c = ii(c, d, a, b, x[i+ 6], 15, -1560198380);
                b = ii(b, c, d, a, x[i+13], 21,  1309151649);
                a = ii(a, b, c, d, x[i+ 4], 6 , -145523070);
                d = ii(d, a, b, c, x[i+11], 10, -1120210379);
                c = ii(c, d, a, b, x[i+ 2], 15,  718787259);
                b = ii(b, c, d, a, x[i+ 9], 21, -343485551);

                a = add(a, olda);
                b = add(b, oldb);
                c = add(c, oldc);
                d = add(d, oldd);
            }
            return rhex(a) + rhex(b) + rhex(c) + rhex(d);
        };

    return MD5(value);
};



import VueCookie from 'vue-cookie';
import fetchJsonp from 'fetch-jsonp';
import axios from 'axios';

//exports
//module.exports = apm;
export default new Apm({cookies: VueCookie, fetchJsonp: fetchJsonp, axios: axios});









// WEBPACK FOOTER //
// ./pc/common/plugin/apm.js